import { Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

export function NotFoundPage() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <Card style={{ maxWidth: 480 }}>
        <CardBody className="text-center">
          <h2 className="mb-3">404 · View existiert nicht</h2>
          <Link to="/">Zurück zur Startseite</Link>
        </CardBody>
      </Card>
    </div>
  );
}
